import { get } from './base-fetch';

export const fetchPptFile = async (projectId: string) =>
  get('v4/export/ppt/' + projectId);
